<template>
  <component :is="headingType" :class="classSize"><slot /></component>
</template>

<script setup lang="ts">
/**
 * Core typography component for displaying text in a heading style.  Renders H1 - H6 depending on size.
 * Size Options: `0, 1, 2, 3, 4, 5, 6`
 *
 * ```
 * import xHeading from '@/components/shared/x-heading'
 *
 * <x-heading size="1">Lorem Ipsum</x-heading>
 * ```
 */
interface XHeadingProps {
  size?: '0' | '1' | '2' | '3' | '4' | '5' | '6'
}
import { computed } from 'vue'

const props = withDefaults(defineProps<XHeadingProps>(), {
  size: '1',
})

const headingType = computed(() => `h${props.size === '0' ? '1' : props.size}`)
const classSize = computed(() => 'title' + props.size)
</script>
